export const ALLOWED_DOMAIN = "writetheworld.org";
